import { Box, Typography } from '@mui/material'
import React from 'react'
import { Motion } from './Motion';
import { fullCenter } from '../base';

export default function Button({ text, white = false, sx = {}, onClick = () => { console.error("Button on click not set! " + text) }, sxText = {} }) {
    return (
        <Motion scale={1.01}>
            <Box sx={{
                border: white ? '2px solid #EDF1F3' : 'none', borderRadius: '50px',
                bgcolor: white ? "white" : "#0165F4", cursor: 'pointer', width: '100%', height: '46px', ...fullCenter, ...sx,
            }} onClick={onClick}>
                {text && <Typography variant='button_text' sx={{ color: white ? '#6C7278' : 'white', fontWeight: 'bold', ...sxText }}>{text}</Typography>}
            </Box>
        </Motion>
    )
}
